import * as React from "react";

const TextArea = (props: any) => (
  <svg width={64} height={64} viewBox="0 0 64 64" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" d="M11 22h43v20H11z" />
      <path d="M10 22v20h44V22H10z" stroke="#7B838C" strokeWidth={4} />
      <path
        d="M16 28h24M16 34h16"
        stroke="#7B838C"
        strokeWidth={2}
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export default TextArea;

